import React, { Component } from 'react'
import BalanceScreen from './screens/BalanceScreen'
import TransferScreen from './screens/TransferScreen'
import SuccessScreen from './screens/SuccessScreen'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    currentScreen: state.bankSimulator.currentScreen,
    transactionHistory: state.bankSimulator.transactionHistory,
  }
}

@connect(mapStateToProps)
class InternetBankingSimulatorApp extends Component {
  renderContent() {
    switch (this.props.currentScreen) {
      case 'dashboard':
        return <BalanceScreen />
      case 'transfer':
        return <TransferScreen />
      case 'success':
        return <SuccessScreen />
      default:
        return <BalanceScreen />
    }
  }

  render() {
    return (
      <div className="smartphone">
        <div className="content">{this.renderContent()}</div>
      </div>
    )
  }
}

export default InternetBankingSimulatorApp



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/index.js